import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import ContinueCancelButtons from "../../../../shared/components/ContinueCancelButtons";
import BackAnchor from "../../../../shared/components/BackAnchor";
import PersonalDetailsForm from "./forms/PersonalDetailsForm";
import { NavigationLinkButton } from "../../../../shared/components/RegularComponents";
import { useSelector } from "react-redux";
import HomeAddressForm from "../../HomeInformation/components/forms/HomeAddressForm";

const PersonalInformationView = ({ t, i18n, setIsError }) => {
  const navigate = useNavigate();

  const { questionDataList, mailingAddressSame, homeAddress, mailingAddress, houseOwnOrRent } =
    useSelector((state) => state?.app);

  const { streetAddress } = homeAddress;
  const { street } = mailingAddress;

  const otherAdult =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 7)
    ].questionAnswer?.toLowerCase() === "yes";
  const moreAdults =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 8)
    ].questionAnswer?.toLowerCase();

  const [validatePersonNameForm, setValidatePersonNameForm] = useState();
  const [showPrivacyNotice, setShowPrivacyNotice] = useState(false);
  const [validHomeAddress, setHomeValid] = useState("");
  const [validMailingAddress, setValidMailing] = useState("");
  const [validateHomeAddressForm, setHomeValidateAddressForm] = useState();
  const [validateMailingAddressForm, setValidateMailingAddressForm] =
    useState();
  const [
    validMailingAddressSameDifferent,
    setValidMailingAddressSameDifferent
  ] = useState(mailingAddressSame);

  const { search } = useLocation();
  const url = new URLSearchParams(search);
  const isSummary = url?.get("isSummary");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onNext = () => {
    try {
      // Need to try saving here will all data
      const newPersonData = validatePersonNameForm();
      const isHomeAddressValid = validateHomeAddress();
      if (newPersonData && isHomeAddressValid) {
        // const sinNumber = newPersonData?.socialInsuranceNumber?.replace(
        //   / /g,
        //   ""
        // );
        // const applicantSin = { applicantSin: sinNumber?.replace(/ /g, "") };
        // To Do Add sin check promise
        // const sinCheckPromise = dispatch(checkSIN(applicantSin));
        // sinCheckPromise.then((result) => {
        // if (result === "Passed!") {
        // dispatch(setQuestionAnswer(11, "Yes"));
        if (isSummary === "true") {
          navigate(`/${i18n.language}${t("routes.review_summary")}`);
        } else if (otherAdult || moreAdults === 'two or more adults(with kids)' || moreAdults === 'two or more adults(no kids)') {
          navigate(`/${i18n.language}${t("routes.other_adults_form")}`);
        } else {
          navigate(`/${i18n.language}${t("routes.heat_your_home")}`);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const validateHomeAddress = () => {
    let newHomeAddressData = validateHomeAddressForm();
    if (
      newHomeAddressData === false ||
      !streetAddress ||
      !streetAddress?.toString()?.length > 0 ||
      homeAddress?.postalCode === null ||
      homeAddress?.postalCode === "" ||
      homeAddress?.city === null ||
      homeAddress?.city === "" ||
      homeAddress?.postalCode?.length < 5
    ) {
      setHomeValid(validHomeAddress === false ? "false" : false);
    }
    let newMailingAddressData;
    if (mailingAddressSame === true || mailingAddressSame === false) {
      newMailingAddressData =
        mailingAddressSame === false ? validateMailingAddressForm() : true;
      if (
        newMailingAddressData === false &&
        (mailingAddress?.city === null || mailingAddress?.city === "")
      ) {
        setValidMailing(false);
      }
      setValidMailingAddressSameDifferent(true);
    } else {
      setValidMailingAddressSameDifferent(false);
    }
    if ((!mailingAddressSame && !street) || !street?.toString()?.length > 3) {
      setValidMailing(false);
    }
    if (
      newHomeAddressData !== false && newHomeAddressData?.streetAddress?.toString()?.length > 0 &&
      newHomeAddressData?.city &&
      newMailingAddressData &&
      (mailingAddressSame === true || mailingAddressSame === false) && houseOwnOrRent !== ''
    ) {
      return true;
    }
  };

  return (
    <div>
      <div className="container">
        <main>
          <article>
            <div className="row" style={{ paddingTop: "1em" }}></div>
            <BackAnchor backPath={"routes.harp_qualify"} />
            <div className="row">
              <div className="col-xs-12 col-sm-8">
                <h1 style={{ marginTop: "1.5em" }}>
                  {t("personal_information.header")}
                </h1>
              </div>
              <div className="col-xs-12 col-sm-8">
                <div style={{ marginBottom: "2em" }} className="row">
                  <div
                    className="col-xs-12 col-sm-12"
                    style={{
                      cursor: "pointer",
                      paddingBottom: "0"
                    }}
                    onClick={() => {
                      setShowPrivacyNotice(!showPrivacyNotice);
                    }}
                  >
                    <hr style={{ marginBottom: "1.5em" }} />
                    <i
                      className="fa fa-lock"
                      aria-hidden="true"
                      style={{
                        color: "#0058a4",
                        fontSize: "20px",
                        paddingRight: "5px"
                      }}
                    ></i>{" "}
                    <NavigationLinkButton
                      id="privacy-notice"
                      text={t("home_information.privacy_link")}
                      onClick={() => {
                        setShowPrivacyNotice(!showPrivacyNotice);
                      }}
                    />{" "}
                    {!showPrivacyNotice && (
                      <i
                        className="fa fa-plus"
                        aria-hidden="true"
                        style={{
                          color: "#0058a4",
                          fontSize: "20px",
                          paddingLeft: "5px"
                        }}
                      ></i>
                    )}
                    {showPrivacyNotice && (
                      <i
                        className="fa fa-minus"
                        aria-hidden="true"
                        style={{
                          color: "#0058a4",
                          fontSize: "20px",
                          paddingLeft: "5px"
                        }}
                      ></i>
                    )}
                    <hr style={{ marginTop: "1.5em" }} />
                  </div>
                </div>
                {showPrivacyNotice && (
                  <div className="timeline row">
                    <ol>
                      <li className="timeline-item col-xs-10 col-md-10">
                        <h2 style={{ marginTop: 0 }}>
                          {t("home_information.privacy_header")}
                        </h2>
                        <div
                          style={{
                            borderLeft: "5px solid #0a43c9",
                            marginLeft: "10px"
                          }}
                          className="step-content"
                        >
                          <p>
                            {t("home_information.privacy_para1")}
                            <a
                              href={`${t(
                                "home_information.privacy_page_link"
                              )}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {t("home_information.privacy_link_text")}
                            </a>
                            {t("home_information.privacy_para1_1")}
                            <a
                              href={`${t(
                                "home_information.opt_out_page_link"
                              )}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {t("home_information.opt_out_text")}
                            </a>
                            {t("home_information.privacy_para1_2")}
                          </p>
                          <br />
                          <p>{t("home_information.privacy_para2")}</p>
                        </div>
                      </li>
                    </ol>
                  </div>
                )}
              </div>
            </div>

            <div style={{ paddingBottom: "1.5em" }} className="row">
              <div className="col-xs-12 col-md-8">
                <PersonalDetailsForm
                  setValidateForm={setValidatePersonNameForm}
                  setIsError={setIsError}
                  language={i18n.language}
                />
              </div>
            </div>
            <div style={{ paddingBottom: "1.5em" }} className="row">
              <div className="col-xs-11 col-sm-8 col-lg-12">
                <HomeAddressForm
                  setValidateForm={setHomeValidateAddressForm}
                  setValidateMailingAddressForm={setValidateMailingAddressForm}
                  setIsError={setIsError}
                  validMailingAddress={validMailingAddress}
                  validHomeAddress={validHomeAddress}
                  validMailingAddressSameDifferent={
                    validMailingAddressSameDifferent
                  }
                />
              </div>
            </div>
            <ContinueCancelButtons continueClick={onNext} />
          </article>
        </main>
      </div>
    </div>
  );
};

export default withTranslation("common")(PersonalInformationView);
